export class CompanyNameAlreadyTakenException {}